(function() {
  'use strict';

  /**
   * Moves the Custom Price Calculator out of product-form__buttons container
   * and places it in its own container after the product description for proper layout
   */
  function moveCalculatorToProperLocation() {
    // Find the calculator - it might have different selectors
    const calculator = document.getElementById('calculator');
    if (!calculator) return false;

    // Find the product form buttons container (where calculator might be currently located)
    const buttonsContainer = calculator.closest('.product-form__buttons');
    
    // Find the form element
    const form = buttonsContainer 
      ? buttonsContainer.closest('form')
      : calculator.closest('form');
    
    if (!form) return false;

    // Find the product form component (parent of form)
    const productFormComponent = form.closest('product-form-component, .product-form');
    if (!productFormComponent) return false;

    // Find the common parent that contains both description and form
    let commonParent = productFormComponent.parentElement;
    let descriptionElement = null;
    
    // Try to find the product description element (rte-formatter with product_description in class)
    let searchScope = commonParent;
    let searchDepth = 0;
    const maxDepth = 5; // Prevent infinite loops
    
    while (searchScope && !descriptionElement && searchDepth < maxDepth) {
      // Look for rte-formatter element with product_description in class name
      const rteElements = searchScope.querySelectorAll('rte-formatter');
      for (let i = 0; i < rteElements.length; i++) {
        const rte = rteElements[i];
        if (rte.className && rte.className.includes('product_description')) {
          descriptionElement = rte;
          break;
        }
      }
      
      // If not found, try alternative selectors
      if (!descriptionElement) {
        // Try looking for text-block with product_description
        const textBlocks = searchScope.querySelectorAll('[class*="product_description"]');
        if (textBlocks.length > 0) {
          descriptionElement = textBlocks[0];
        }
      }
      
      // If still not found, go up one level
      if (!descriptionElement) {
        searchScope = searchScope.parentElement;
        searchDepth++;
      }
    }
    
    // Update commonParent to the scope where we found description
    if (descriptionElement) {
      commonParent = descriptionElement.parentElement || commonParent;
    }
    
    // Fallback: if description not found, try to find price container (for other pages)
    let priceContainer = null;
    if (!descriptionElement) {
      searchScope = commonParent;
      searchDepth = 0;
      
      while (searchScope && !priceContainer && searchDepth < maxDepth) {
        priceContainer = searchScope.querySelector('product-price, .price-product-container');
        if (priceContainer) {
          const parentProductPrice = priceContainer.closest('product-price');
          if (parentProductPrice && parentProductPrice !== priceContainer) {
            priceContainer = parentProductPrice;
          }
        }
        
        if (!priceContainer) {
          searchScope = searchScope.parentElement;
          searchDepth++;
        }
      }
      
      if (priceContainer) {
        commonParent = priceContainer.parentElement || commonParent;
      }
    }
    
    if (!commonParent) return false;

    // Check if calculator is already moved and in correct position
    const currentWrapper = calculator.closest('.calculator-wrapper-container');
    if (currentWrapper) {
      if (descriptionElement) {
        // Check if wrapper comes after description element
        const allChildren = Array.from(commonParent.children);
        const descIndex = allChildren.indexOf(descriptionElement);
        const wrapperIndex = allChildren.indexOf(currentWrapper);
        
        // If wrapper is already after description, we're good
        if (descIndex !== -1 && wrapperIndex > descIndex) {
          return true; // Already in correct position, skip
        }
        
        // If wrapper exists but is in wrong position, remove it and extract calculator
        const calcInside = currentWrapper.querySelector('#calculator');
        if (calcInside) {
          currentWrapper.parentNode.removeChild(currentWrapper);
          // Calculator will be re-wrapped below
        } else {
          return false; // Calculator not found in wrapper, something's wrong
        }
      } else if (priceContainer) {
        // Check position relative to price (fallback)
        const allChildren = Array.from(commonParent.children);
        const priceIndex = allChildren.indexOf(priceContainer);
        const wrapperIndex = allChildren.indexOf(currentWrapper);
        
        if (priceIndex !== -1 && wrapperIndex > priceIndex) {
          return true; // Already in correct position, skip
        }
        
        const calcInside = currentWrapper.querySelector('#calculator');
        if (calcInside) {
          currentWrapper.parentNode.removeChild(currentWrapper);
        } else {
          return false;
        }
      } else {
        // Neither description nor price found, but wrapper exists
        // Check if it's in a reasonable position (before buttons)
        if (buttonsContainer) {
          const allChildren = Array.from(commonParent.children);
          const buttonsIndex = allChildren.indexOf(buttonsContainer);
          const wrapperIndex = allChildren.indexOf(currentWrapper);
          
          if (buttonsIndex !== -1 && wrapperIndex < buttonsIndex) {
            return true; // Already in reasonable position
          }
        }
      }
    }
    
    let insertAfterElement = null;
    let targetParent = commonParent;

    // Priority: description element first, then price container, then fallback
    if (descriptionElement) {
      // Insert after the description element
      insertAfterElement = descriptionElement;
      targetParent = descriptionElement.parentElement;
    } else if (priceContainer) {
      // Fallback: insert after price container (for pages with price visible)
      insertAfterElement = priceContainer;
      targetParent = priceContainer.parentElement;
    } else {
      // If neither found, look for it in a wider scope
      const productInfo = form.closest('#ProductInformation-template, .product-information__grid, [id^="ProductInformation"]');
      if (productInfo) {
        // Try description first
        const widerDesc = productInfo.querySelector('rte-formatter[class*="product_description"], [class*="product_description"]');
        if (widerDesc) {
          insertAfterElement = widerDesc;
          targetParent = widerDesc.parentElement;
        } else {
          // Then try price
          const widerPriceContainer = productInfo.querySelector('product-price, .price-product-container');
          if (widerPriceContainer) {
            insertAfterElement = widerPriceContainer;
            targetParent = widerPriceContainer.parentElement;
          }
        }
      }
    }
    
    // Final fallback options
    if (!insertAfterElement) {
      if (buttonsContainer) {
        // Fallback: if no description/price found, place before buttons container
        insertAfterElement = null;
        targetParent = buttonsContainer.parentElement;
      } else {
        // Last resort: place at the beginning of the form
        targetParent = form;
        insertAfterElement = null;
      }
    }

    if (!targetParent) return false;

    // Create a wrapper container for the calculator
    const calculatorWrapper = document.createElement('div');
    calculatorWrapper.className = 'calculator-wrapper-container';
    calculatorWrapper.style.cssText = 'width: 100%; margin-bottom: var(--gap, 10px);';

    // Remove calculator from its current location (if not already removed)
    if (calculator.parentNode) {
      calculator.parentNode.removeChild(calculator);
    }
    
    // Wrap calculator in the new container
    calculatorWrapper.appendChild(calculator);
    
    // Insert the wrapper after the description element (or price/fallback)
    if (insertAfterElement) {
      // Use insertAdjacentElement for cleaner insertion after the element
      insertAfterElement.insertAdjacentElement('afterend', calculatorWrapper);
    } else if (buttonsContainer) {
      // Fallback: insert before buttons container
      targetParent.insertBefore(calculatorWrapper, buttonsContainer);
    } else {
      // Last resort: append to form
      targetParent.appendChild(calculatorWrapper);
    }

    return true;
  }

  /**
   * Main function to handle calculator relocation
   */
  function relocateCalculator() {
    // Try to move immediately if calculator exists
    if (moveCalculatorToProperLocation()) {
      return;
    }

    // If calculator doesn't exist yet, set up observers
    setupObservers();
  }

  /**
   * Set up MutationObserver to watch for calculator injection
   */
  function setupObservers() {
    // Watch the entire document body for calculator injection
    const observer = new MutationObserver(function(mutations) {
      // Check if calculator appeared
      const calculator = document.getElementById('calculator');
      if (calculator) {
        // Try to move it to proper location
        moveCalculatorToProperLocation();
      }
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also watch specific product form containers
    const productForms = document.querySelectorAll('.product-form, product-form-component, form[data-type="add-to-cart-form"]');
    productForms.forEach(function(form) {
      observer.observe(form, {
        childList: true,
        subtree: true
      });
    });

    // Watch product info container for description and price element appearance
    const productInfoContainers = document.querySelectorAll('#ProductInformation-template, .product-information__grid, .group-block-content, [id^="ProductInformation"]');
    productInfoContainers.forEach(function(container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });

    // Also check if description or price appears and calculator needs repositioning
    const elementObserver = new MutationObserver(function(mutations) {
      const calculator = document.getElementById('calculator');
      if (calculator) {
        // Check for description first
        const descElement = document.querySelector('rte-formatter[class*="product_description"], [class*="product_description"]');
        if (descElement) {
          moveCalculatorToProperLocation();
        } else {
          // Fallback: check for price
          const priceContainer = document.querySelector('product-price, .price-product-container');
          if (priceContainer) {
            moveCalculatorToProperLocation();
          }
        }
      }
    });

    // Watch for description and price element appearance
    elementObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Initialize when DOM is ready
   */
  function init() {
    // Try immediately
    relocateCalculator();

    // Also try after delays to catch late injections
    setTimeout(relocateCalculator, 500);
    setTimeout(relocateCalculator, 1000);
    setTimeout(relocateCalculator, 2000);

    // Listen for custom events that might indicate calculator injection
    window.addEventListener('calculator-loaded', relocateCalculator);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded
    init();
  }

  // Also try on window load (all resources loaded)
  window.addEventListener('load', function() {
    setTimeout(relocateCalculator, 100);
  });
})();

